<template>
  <div class="content content--sub">
    <OverlayLoader v-if="!$store.getters.solutionsLoaded || !section"></OverlayLoader>
    <template v-if="section">
      <MyHeader :breadcrumbItems="[
        {
          name: section.value,
          path: $route.path
        }
      ]" />

      <header class="content-header">
        <h1>{{ section.value }}</h1>
      </header>

      <div class="container main-content">
        <div class="row boxes-row">
          <div class="col-lg-3" v-for="solution in solutions" :key="solution.idSolution">
            <BoxStory :box="solution" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import BoxStory from '@/components/solutions/BoxStory'
import OverlayLoader from "@/components/general/OverlayLoader";
import settings from "@/settings";
import settingUser from "@/api/settingUser";
import moment from "moment";
export default {
  name: "Portfolio",
  components: { OverlayLoader, MyHeader, BoxStory },
  computed: {
    section() {
      return this.$store.getters.sectionByCodeAndSlug(settings.MODULES.SOLUTIONS, this.$route.params.slug)
    },
    solutions() {
      return this.$store.getters.solutions
    }
  },
  mounted() {
    // Only call these if section exists
    if (this.section) {
      console.log('Section value:', this.section.value);
      console.log('Section:', this.section);
      window._paq.push(['setDocumentTitle', this.section.value]);
      window._paq.push(['trackPageView']);
      this.updateNotificationDate();
    }
  },
  created() {
    // Add debug logging
    console.log("Route params:", this.$route.params);
    console.log("Sections loaded:", this.$store.getters.sectionsLoaded);

    // First load sections if needed
    if (!this.$store.getters.sectionsLoaded) {
      const promise = this.$store.dispatch('getSections');
      if (promise && typeof promise.then === 'function') {
        promise.then(() => {
          // Check if section was found after loading
          console.log("Section after loading:", this.section);
          if (!this.section) {
            console.warn("Section not found for slug:", this.$route.params.slug);
          }
          this.getSolutions();
        });
      } else {
        this.$store.dispatch('getSections');
        setTimeout(() => {
          console.log("Section after timeout:", this.section);
          this.getSolutions();
        }, 500);
      }
    } else {
      // If sections are already loaded but section still not found
      if (!this.section) {
        console.warn("Sections loaded but section not found for slug:", this.$route.params.slug);
      }
      this.getSolutions();
    }
  },
  methods: {
    getSolutions() {
      if (this.section && this.section.idSettingCompany) {
        this.$store.dispatch('getSolutions', {
          Content_idType_idContent: this.section.idSettingCompany,
          _embed: 1,
        });
      } else {
        // Force solutions loaded state to true even if we can't load them
        // This will make the loader disappear
        this.$store.commit('SET_SOLUTIONS_LOADED', true);
        console.warn("Cannot load solutions - section or idSettingCompany not found");
      }
    },

    updateNotificationDate() {
      // Only update if section exists
      if (this.section && this.section.idSettingCompany) {
        settingUser.createSettingUser({
          idUser: this.$store.getters.user.idUser,
          idSettingCompany: this.section.idSettingCompany,
          valueDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        }, () => {
          this.$store.dispatch('updateNotification', this.section.idSettingCompany);
          this.$store.dispatch('getUserInfo');
        });
      }
    }
  },
}
</script>
